import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const w5Web = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  await topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ-人差し指のジョイントパーツ
  await jointOfIndexFinger(ctx, webColor, laceColor, 3, 30, printLeatherTypeValue)
  await jointOfIndexFinger(ctx, webColor, laceColor, -24, 90, printLeatherTypeValue)
  await jointOfIndexFinger(ctx, webColor, laceColor, -45, 160, printLeatherTypeValue)
  await jointOfCatchFace(ctx, webColor, laceColor, -10, 12, printLeatherTypeValue)
  await jointOfCatchFace(ctx, webColor, laceColor, 38, 57, printLeatherTypeValue)
  await jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56, printLeatherTypeValue)
  await jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30, printLeatherTypeValue)
  await jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5, printLeatherTypeValue)

  // web本体のflatパーツ
  const drawPath = () => {
    ctx.beginPath()
    ctx.moveTo(549, 81) // 左上
    ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
    ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
    ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
    ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
    ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
    ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawPath, webColor)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}
